module.exports = __webpack_public_path__ + "media/images/skull3-7c3cff7d3bbeca4cdf8978a337e8baec.png";